import getLogger from '@ignitesales/logger-es';

const logger = getLogger({ component: 'initializeState' });

let stateHelper = null;
const serviceWaitTimeout = 30000;

const initializeState = async ({ loadInitialState }) => {
  stateHelper = await loadInitialState();
  return stateHelper;
};

const appStateInitialized = () => {
  const waitStart = Date.now();

  return new Promise((resolve, reject) => {
    const checkForServices = () => {
      logger.info('checking for main store availability');
      if (stateHelper) {
        logger.info('main store is ready');
        return resolve(true);
      }

      const elapsed = Date.now() - waitStart;
      if (elapsed >= serviceWaitTimeout) {
        return reject(new Error('main store is unavailable'));
      }

      logger.info('waiting for main store availability');
      setTimeout(() => checkForServices(), 200);
    };

    checkForServices();
  });
};

export { initializeState, appStateInitialized };

export default initializeState;
